import React from "react";
import { DefaultDataTable } from "../../../components/dataTable/DefaultDataTable";

export const ConsultaRemessaList = props => <DefaultDataTable data={props} />;
